import { AxiosResponse } from "axios";
import HttpService from "src/services/httpService";
import RouteService from "src/services/routeService";
import { ApiResponse, BasicApiResponse } from "src/types";

import { unpackError } from "@dashboard/devices/api/helpers";

export async function updateEmailConfig(payload: API.EmailConfig) {
    try {
        const endpoint = await RouteService.getConfigRoute();
        const response: AxiosResponse<BasicApiResponse> = await HttpService.put(endpoint + "email", payload);
        return response.data;
    } catch (error) {
        throw unpackError(error);
    }
}

export async function fetchEmailConfig() {
    try {
        const endpoint = await RouteService.getConfigRoute();
        const response: AxiosResponse<ApiResponse<API.EmailConfig>> = await HttpService.get(endpoint + "email");
        return response.data;
    } catch (error) {
        throw unpackError(error);
    }
}

export async function sendTestEmail() {
    try {
        const endpoint = await RouteService.getConfigRoute();
        const response: AxiosResponse<BasicApiResponse> = await HttpService.post(endpoint + "email");
        return response.data;
    } catch (error) {
        throw unpackError(error);
    }
}
